import * as React from 'react';
import autobind from 'autobind-decorator';
import { Button, Modal } from 'antd';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';
import { TextView } from 'src/core/ui/text.view';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { ContractEditorController } from '../../../contract/parts/contract-editor.controller';

interface ProductContractsViewProps extends ComponentViewProps<ProductItem | TourItineraryItem> {
	mode: ControlMode;
	dataService: DataSet<ContractItem>;
	onItemDoubleClicked?: (item: ContractItem) => any;
	contextService: any;
	cloneAccept: (year: number, product: ProductItem | TourItineraryItem, contractClone?: ContractItem, contractCloneId?: number) => void
}

@observer
export class ProductContractsView extends React.Component<ProductContractsViewProps, any> {
	constructor(props) {
		super(props);
	}

	@observable
	showYearDialog = false;

	@observable
	showYearProductDialog = false;

	@observable
	contractIdClone: number;

	contractClone: ContractItem;

	@observable
	productId: number;

	@observable
	year: number = new Date().getFullYear() + 1;
   
	@autobind
	private closeDialog(ev?: React.MouseEvent<HTMLButtonElement>) {
		ev.preventDefault();
		this.showYearDialog = false;
		this.showYearProductDialog = false;
	}

	@autobind
	private acceptDialog(ev?: React.MouseEvent<HTMLButtonElement>) {
		if (this.year && this.props.model && this.contractIdClone) {
			this.props.cloneAccept(this.year, this.props.model, this.contractClone, this.contractIdClone);
			this.closeDialog(ev);
		}
	}

	@autobind
	deleteContracts(contracts: ContractItem[]) {
		for (const contract of contracts) {
			contract.product = undefined;
			contract.dateBands = undefined;
		}
		return contracts;
	}

	@autobind
	cloneClick(contractId: number) {
		this.showYearDialog = true;
		this.contractIdClone = contractId;
	}

	@autobind
	cloneGivenProductClick() {
		this.showYearProductDialog = true;
	}

	render() {
		const dataService = this.props.dataService;
		const columns: Column[] = [
			{
				key: 'clone',
				title: '',
				dataIndex: 'clone',
				className: 'pt-0 pb-0',
				render: (text, record, index) => {
					return <Button icon="plus-circle-o"
						onClick={() => this.cloneClick(record.id)}
						disabled={this.props.mode == 'display' ||( record.id== null ||record.id<0)}>
						Clone
					</Button>
				}
			},
			{
				key: 'id',
				title: '#',
				dataIndex: 'id'
			},
			{
				key: 'displayName',
				title: 'Contract',
				dataIndex: 'displayName',
				render: (text, record, index) => {
					return record.dynamicProperties.displayName.en;
				}
			},

		];
		return (
			<div>
				<Modal
					visible={this.showYearDialog}
					onCancel={this.closeDialog}
					title="Clone"
					maskClosable={false}
					footer={[
						<Button key='confirm' type="primary" onClick={this.acceptDialog}>Ok</Button>,
						<Button key='cancel' onClick={this.closeDialog}>Cancel</Button>
					]}>
					<TextView mode={this.props.mode}
						label='Year'
						value={this.year}
						onChanged={newVal => this.year = parseInt(newVal)}
					/>
				</Modal>
				<Modal
					visible={this.showYearProductDialog}
					onCancel={this.closeDialog}
					title="Clone"
					maskClosable={false}
					footer={[
						<Button key='confirm' type="primary" onClick={this.acceptDialog}>Ok</Button>,
						<Button key='cancel' onClick={this.closeDialog}>Cancel</Button>
					]}>
					<ProductEditorController
						mode={'edit'}
						required
						label={"Product"}
						onChanged={(value) => {
							this.productId = (value != null) ? value.id : null;
						}}
						value={this.productId}
						setBusy={this.props.setBusy}
					/>
					<ContractEditorController
						mode={this.productId != null ? 'edit' : 'display'}
						required
						label={"Contract"}
						onChanged={(value) => {
							this.contractIdClone = (value != null) ? value.id : null;
						}}
						productId={this.productId}
						value={this.contractIdClone}
						setBusy={this.props.setBusy}
					/>
					<TextView mode={this.props.mode}
						label='Year'
						value={this.year}
						onChanged={newVal => this.year = parseInt(newVal)}
					/>
				</Modal>
				<DataTableView
					mode={this.props.mode}
					toolbarLeftItems={[
						{
							icon: 'plus-circle-o',
							key: 'add-pax',
							name: 'Clone',
							onClick: this.cloneGivenProductClick,
							disabled: this.props.mode == 'display' 
						}
					]}
					createNewItem={() => this.props.onItemDoubleClicked(null)}
					setBusy={this.props.setBusy}
					beforeDeleteItem={this.deleteContracts}
					columns={columns}
					model={dataService}
					hideToolbar={ToolbarVisibility.hideFooter | ToolbarVisibility.hidePagination | ToolbarVisibility.hideSearch}
					itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/form/parts/product-contracts.view.tsx